$(function() {
	
	$('.footer .branding-container .container>.flex-box').slick({
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	})
	
	$('.footer-info-heading').click(function() {
		$(this).siblings('.footer-info-list').toggleClass('--open');
		$(this).toggleClass('--active');
	})
})
	
	
